module.exports = __webpack_public_path__ + "static/media/DataAna.fb4b548b.svg";